<template>
  <div id="video-player">
    <div :class="minimal ? 'minimal' : 'normal'">
      <video
        id="stream-player"
        class="video-js"
        width="100%"
        :style="{
          objectFit: `${room.cellPhoneMode ? 'cover' : 'contain'} !important`,
        }"
        webkit-playsinline="true"
        playsinline="true"
        autoplay
        :muted="!video.audio"
      ></video>
    </div>
    <div
      v-if="(player.video && player.video.paused) || (player.video && player.video.paused && isIos)"
      id="video-controls"
      class="text-center"
    >
      <div>
        <v-btn
          fab
          text
          @click="togglePlay()"
        >
          <Icon
            :width="60"
            :height="60"
            :color="'#fff'"
            :icon="'play'"
          />
        </v-btn>
      </div>
      <!-- <div>
          <v-btn
            fab
            x-small
            text
            @click="mute()"
          >
            <v-icon
              color="white"
              size="25"
            >
              {{ player.video.volume ? 'mdi-volume-high' : 'mdi-volume-off' }}
            </v-icon>
          </v-btn>
        </div> -->
      <!-- <div class="ml-auto">
          <v-btn
            fab
            x-small
            text
            @click="fullScreen()"
          >
            <v-icon
              color="white"
              size="25"
            >
              mdi-fullscreen
            </v-icon>
          </v-btn>
        </div> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import videojs from '@mux/videojs-kit'
import '@mux/videojs-kit/dist/index.css'

require('@/plugins/Orientation')

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    room: {
      type: Object,
      default: null
    },
    video: {
      type: Object,
      default: null
    },
    isIos: {
      type: Boolean,
      default: true
    },
    minimal: {
      type: Boolean,
      default: false
    },
    muxVideoEnvKey: {
      type: String,
      default: process.env.VUE_APP_MUX_VIDEO_ENV_KEY
    }
  },
  watch: {
    'video.audio': function () {
      this.mute()
    },
    'orientation': function (orientation) {
      if (orientation === 'landscape') {
        this.video.cellphoneMode = false
        this.$widget.maximizeToggler(true)
      }
    }
  },
  computed: {
    orientation () {
      return this.$store.state.widget.orientation
    }
  }
})
export default class Video extends Vue {
  data () {
    return {
      player: {
        mux: null,
        video: null,
        volume: 1
      }
    }
  }

  beforeDestroy() {
    if (this.player.mux) {
      this.player.mux.dispose()
    }
  }

  async mounted () {
    this.setPlayer()
  }

  play () {
    if (!this.player.video) {
      return false
    }

    this.player.video.play()
      .then(() => {
        this.$forceUpdate()
      })
      .catch((error) => {
        console.log('do something if you want to handle or track this error', error)
      })
  }

  pause () {
    if (!this.player.video) {
      return false
    }

    this.player.video.pause()
    this.$forceUpdate()
  }

  mute () {
    if (!this.player.video) {
      return false
    }

    this.player.volume = this.video.audio ? 1 : 0
    this.player.video.volume = this.player.volume
    this.$forceUpdate()
  }

  // setVolume () {
  //   if (!this.player.video) {
  //     return false
  //   }

  //   this.player.video.volume = this.player.volume
  //   this.$forceUpdate()
  // }

  // fullScreen () {
  //   if (!this.player.video) {
  //     return false
  //   }

  //   if (this.player.video.requestFullscreen) {
  //     this.player.video.requestFullscreen()
  //   } else if (this.player.video.mozRequestFullScreen) {
  //     this.player.video.mozRequestFullScreen()
  //   } else if (this.player.video.webkitRequestFullscreen) {
  //     this.player.video.webkitRequestFullscreen()
  //   } else if (this.player.video.msRequestFullscreen) {
  //     this.player.video.msRequestFullscreen()
  //   }
  // }

  togglePlay () {
    if (this.player.video.paused || this.player.video.ended) {
      this.play()
    } else {
      this.pause()
    }
  }

  async setPlayer () {
    const video = document.querySelector('video#stream-player')

    if (!video) {
      return false
    }

    const options = {
      plugins: {
        mux: {
          debug: false,
          data: {
            env_key: this.muxVideoEnvKey,
            video_title: this.room.title
          }
        }
      }
    }

    this.player.mux = videojs('stream-player', options)

    this.player.mux.ready(() => {
      this.player.mux.src({
        src: this.room.mux_stream.playback_id,
        type: 'video/mux'
      })
    })

    this.player.video = document.querySelector('#stream-player video')

    if (this.$route.query.fromLink) {
      this.player.video.volume = 0
      this.$emit('offAudioStream')
    }

    this.play()
  }
}
</script>

<style>
  #video-player .video-js {
    height: 100%;
    width: 100%;
  }
  .normal {
    height: calc(100vh - 36px);
    transition: height 0.25s ease-in;
  }

  #video-player .minimal {
    height: 202px !important;
    transition: height 0.25s ease-in;
  }
</style>
